import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { CompanyAccess, CompanyAdmins } from 'src/model/companyAccess.model';
import { AccessType, AdminAccessService } from 'src/services/admin-access.service';
import { CompanyService } from 'src/services/company.service';
import { AccessAction, AccessActionComponent } from '../access-action/access-action.component';
import { AdminCompanyListComponent } from '../admin-company-list/admin-company-list.component';

@Component({
    selector: 'app-admin-access-table',
    templateUrl: './admin-access-table.component.html',
    styleUrl: './admin-access-table.component.scss',
    standalone: false
})
export class AdminAccessTableComponent implements OnInit {
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private adminAccessService = inject(AdminAccessService);
  private companyService = inject(CompanyService);

  displayedColumns: string[];
  dataSource = new MatTableDataSource();

  @ViewChild(MatSort) sort: MatSort;
  @Input() companyAccessList: CompanyAccess[] = [];

  companyAdminList: CompanyAdmins[] = [];

  companyList: Company[] = [];
  adminFC = new FormControl('');
  filteredCompany: Observable<Company[]>;

  adminList: string[] = [];
  companyFC = new FormControl('');
  filteredAdmin: Observable<string[]>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  async ngOnInit(): Promise<void> {
    this.companyList = await this.companyService.getAllCompanies(),
    this.companyAdminList = this.getCompanyAdmins();
    this.adminList = [...new Set(this.companyAdminList.flatMap(c => [c.admin1, c.admin2, c.admin3]))].filter(a => a?.length > 0).sort();

    this.dataSource = new MatTableDataSource(this.companyAdminList);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    this.displayedColumns = ["companyCode", "admin1", "admin2", "admin3", "others"];

    //filter company
    this.filteredCompany = this.companyFC.valueChanges.pipe(
      startWith(''),
      map(companyCode => this._filterCompanyCodeOptions(companyCode))
    );

    //filter admin
    this.filteredAdmin = this.adminFC.valueChanges.pipe(
      startWith(''),
      map(username => this._filterAdminCodeOptions(username))
    );
  }

  private _filterCompanyCodeOptions(value: string): Company[] {
    const filterValue = value.toLowerCase();
    const filtered = this.companyList.filter(company => { return company.CompanyCode.toLowerCase().includes(filterValue) });

    return filtered;
  }

  private _filterAdminCodeOptions(value: string): string[] {
    const filterValue = value.toLowerCase();
    const filtered = this.adminList.filter(admin => { return admin.toLowerCase().includes(filterValue) });

    return filtered;
  }

  getCompanyAdmins(): CompanyAdmins[] {
    return this.companyList.reduce((acc, comp) => {
      acc.push({
        companyCode: comp.CompanyCode,
        admin1: this.companyAccessList.find((c) => c.CompanyId == comp.ID && c.Priority == this.enums.FIRST_PRIORITY)?.Username ?? '',
        admin2: this.companyAccessList.find((c) => c.CompanyId == comp.ID && c.Priority == this.enums.SECOND_PRIORITY)?.Username ?? '',
        admin3: this.companyAccessList.find((c) => c.CompanyId == comp.ID && c.Priority == this.enums.THIRD_PRIORITY)?.Username ?? '',
        others: this.companyAccessList.filter(access => {
          if (access.CompanyId == comp.ID && ![AccessType.Essential, AccessType.OnDuty].includes(this.adminAccessService.getAccessType(access.Priority, true)))
            return access;
        }),
        companyId: comp.ID
      })
      return acc;
    }, [] as CompanyAdmins[]);
  }

  openChangeAccessModal(companyCode: string, username: string, priority: number) {
    const modalRef = this.sharedService.openModal(AccessActionComponent);
    modalRef.componentInstance.action = AccessAction.Change;
    modalRef.componentInstance.companyAccessList = this.companyAccessList.filter(access => access.CompanyCode == companyCode);
    modalRef.componentInstance.currentAdmin = username;
    modalRef.componentInstance.targetPriority = priority;
  }

  openAssignAccessModal(companyId: number, priority: number) {
    const modalRef = this.sharedService.openModal(AccessActionComponent);
    modalRef.componentInstance.action = AccessAction.Add;
    modalRef.componentInstance.companyAccessList = this.companyAccessList.filter(a => a.CompanyId == companyId);
    modalRef.componentInstance.companies = [companyId];
    modalRef.componentInstance.targetPriority = priority;
  }

  applyFilter(event: any) {
    const filterValue = event.option.value;
    if (filterValue != '')
      this.dataSource.filter = filterValue.trim().toLowerCase();
    else
      this.dataSource.filter = '';
  }

  openOtherPriorityModal(companyId: number, companyCode: string) {
    const modalRef = this.sharedService.openModal(AdminCompanyListComponent);
    modalRef.componentInstance.companyAccessList = this.companyAccessList.filter(a => a.CompanyId == companyId);
    modalRef.componentInstance.companyCode = companyCode;
  }
}
